<template>
  <a-drawer
      title="包含的账号"
      width="900px"
      placement="right"
      :closable="true"
      :visible="visible"
      @close="onClose"
    >
      <div>
      <div class="table-operator">
        <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      </div>
      <!-- <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div> -->
      <a-table
        class="table-div"
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"
        :rowSelection="null"
        @change="handleTableChange">

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical"/>
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down"/></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a href="javascript:;" @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
      <mange-sources-account-modal  ref="modalForm" @ok="modalFormOk" ></mange-sources-account-modal>
    </div>
    </a-drawer>
</template>

<script>
import {JeecgListMixin} from '@/mixins/JeecgListMixin.js'
import {postAction} from '@/api/manage.js'
import mangeSourcesAccountModal from '../modules/mangeSourcesAccountModal'

const columns = [
    {
      title: 'API账号',
      align: "center",
      dataIndex: 'apiAccount',
      width:"150px",
    },
    {
      title: '账号类型',
      align: "center",
      dataIndex: 'apiType_text',
      width:"150px",
    },
    {
      title: '秘钥',
      align: "center",
      dataIndex: 'secretKey',
      width:"330px",
    },
    {
      title: '操作',
      dataIndex: 'action',
      scopedSlots: { customRender: 'action' },
      fixed:"right",
      align:"center",
      width:"200px"
    },
  ];
export default {
  components:{
    mangeSourcesAccountModal
  },
  mixins:[JeecgListMixin],
  data() {
    return {
      visible:false,
      sourcesId:"",
      listData:[],
      columns:columns,
      disableMixinCreated:true,
      url:{
        list:"/goldenHomeMsgMange/selectApiAccountData",
        delete:"/goldenHomeMsgMange/deleteApiAccountData"
      }
    }
  },
  methods: {
    handleAdd () {
      if(!this.sourcesId){
        this.$message.error("找不到相应的sourcesId")
        return
      }
      this.$refs.modalForm.add({
        sourcesId:this.sourcesId
      });
      this.$refs.modalForm.title = "新增";
      this.$refs.modalForm.disableSubmit = false;
    },
    onClose(){
      this.visible=false
      this.initData()
    },
    open(record){
      this.visible=true
      this.sourcesId=record.id;
    },
    loadData (arg) {
        if (!this.url.list) {
            this.$message.error("请设置url.list属性!")
            return
        }
        //加载数据 若传入参数1则加载第一页的内容
        if (arg === 1) {
            this.ipagination.current = 1;
        }
        var params = this.getQueryParams();//查询条件
        params.sourcesId=this.sourcesId,
        this.loading = true;
        this.dataSource=[]
        postAction(this.url.list, params).then((res) => {
            if (res.success) {
                this.dataSource = res.result;
                this.ipagination.total = res.result.total;
                this.pageRefresh ++
            }else{
                this.$message.warning(res.message)
            }  
            if (res.code === 510) {
                this.$message.warning(res.message)
            }
            this.loading = false;
        })
    },
    initData(){
      this.listData=[];
      this.sourcesId="";
    }
  },
  watch:{
    sourcesId(newVal){
      if(newVal){
        this.loadData(1);
      } 
    }
  }
}
</script>

<style lang="less" scoped>
  @import '~@assets/less/common.less';
  .table-div{
    margin-top: 10px;
  }
</style>